import React, { useEffect, useState } from 'react';
import micro_reporter_api from '../../apis/micro-reporter-api';
import {Table, Modal, Button, Spinner} from 'react-bootstrap';
import DownloadForm from './DownloadForm';
import noReport from '../../assets/img/report.png';
import download_icon from '../../assets/img/download.png';
import Utils from "../../libraries/utils";

const ReportList = (props) => {

    const [modalShow, setModalShow] = React.useState(false);
    const [reports, setReports] = useState({reports: {}});
    const [showLoad, setShowLoad] = useState(false);

    let columnMetadataMap = new Map();
    let comingValues = props.values;
    let columnValueMap={};
    let comingOffset = props.offset;
    let comingRowNumber = props.rowNumber;
    let rid = Number(props.rid);

    useEffect(() => {
        requestWithParams(comingValues);
    }, [props.rid, comingValues, comingOffset, comingRowNumber]);

    const requestWithParams = (values) => {
        if(values === undefined){
            values = {};
        }

        let tempColumnMetadataMap = props.columnMetadata;
        tempColumnMetadataMap = toMap(tempColumnMetadataMap);
        if (tempColumnMetadataMap === null || tempColumnMetadataMap.size===0){
            tempColumnMetadataMap = null;
        }

        const model = {columnValueMap: comingValues, columnMetadataMap:tempColumnMetadataMap, offset: comingOffset*comingRowNumber, rows: comingRowNumber+1, rid: rid };

        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(props.reportName), "relatedId": rid};

        const config = {headers};

        (async () => {
            try{
                Utils.loadingScreen("show");
                setShowLoad(true);
                await micro_reporter_api.post('/micro-reporter/report/filter-report', model, config).then(
                    (response) => {
                        if(Object.keys(response.data.resultMap).length<=comingRowNumber) {
                            props.disableButton();
                        }else{
                            props.enableButton();
                        }
                        delete response.data.resultMap[comingRowNumber]
                        setReports({reports: response.data});
                        Utils.loadingScreen("hide");
                        setShowLoad(false);
                    }
                )
            }catch (err) {
                Utils.loadingScreen("hide");
                props.setShowErrorMessage(true);
                setShowLoad(false);
            }finally {
                Utils.loadingScreen("hide");
            }
        })();
    };

    const toMap = (columnMetadataMap) => {
        let res = {};
        for (const [key, value] of Object.entries(columnMetadataMap)) {
            res[value[0]] = value[1];
        }
        return res;
    }


    const renderDownloadButtons = () => {
        if (reports.reports.canViewExport[1]){
            return(
                <div>
                    {/*{renderExcelDownloadButton()}*/}
                    {/*{renderCsvDownloadButton()}*/}
                    <Button onClick={() => setModalShow(true)} style={{marginBottom:"10px", position:"relative", float:"left"}}>
                        <img src={download_icon} alt="download" style={{width:"17px", height:"17px", marginBottom:"4px", marginRight:"5px"}}/>
                        Export
                    </Button>
                </div>
            );
        }else{
            return(
                <div style={{marginTop: props.isAccordionActive? "0":"50px"}}>
                    <div style={{height:"39px", width:"91px", marginBottom: "10px", float: "left"}}>

                    </div>
                </div>
            )
        }
    };


    const renderTable = () => {
        if(reports.reports.columnMetadataMap !== undefined && Object.keys(reports.reports.columnMetadataMap).length > 0){
            for (const [key, value] of Object.entries(reports.reports.columnMetadataMap)) {
                columnMetadataMap.set(key, value);
            }
        }
        if(reports.reports.resultMap !== undefined && Object.keys(reports.reports.resultMap).length > 0){
            props.showPagination(true);
            return(
                <div>
                    {renderDownloadButtons()}
                    <div id="report-list-table-div" style={props.isWidget ? {overflow: "auto", maxHeight: "33vh"}: {}}>
                        <Table striped bordered hover id="report-list-table">
                            <thead>
                            <tr>
                                {renderTableHeader(Object.keys(Object.values(reports.reports.resultMap)[0]))}
                            </tr>
                            </thead>
                            <tbody>
                            {renderTableBody(Object.values(reports.reports.resultMap))}
                            </tbody>
                        </Table>
                    </div>
                    {renderTableInfo()}
                </div>
            );
        }else if(!showLoad){
            props.showPagination(false);
            return(
                    <div id="report-not-found-div">
                        <div id="report-center-div">
                            <img src={noReport} style={{width: "100px"}} alt="No record found."/>
                            <br/>
                            <span>No record found!</span>
                    </div>
                </div>
            );
        }
    };

    const renderTableHeader = (headers) => {
        return headers.map( header => {
            return(
                <th key={header+"table-header"}>{header}</th>
            );
        });
    };

    const renderTableBody = (rows) => {
        return rows.map(row => {
            return(
                <tr key={row.id}>
                    {
                        renderRowItems(row)
                    }
                </tr>
            );
        });
    };

    const renderRowItems = (items) => {
        return Object.entries(items).map(([key, value]) => {
            if (value == null){
                return (
                    <td key={key + "-" + value + "-td"}></td>
                );
            }else if(columnMetadataMap.get(key).toLowerCase()==="timestamp" || columnMetadataMap.get(key).toLowerCase()==="datetime"){
                const date = new Date(value);
                return(
                    <td key={key + "-" + date + "-td"}>{dateFormat(date)}</td>
                );
            }else if(columnMetadataMap.get(key).toLowerCase() === "date"){
                const date = new Date(value);
                return(
                    <td key={key + "-" + date + "-td"}>{dateFormatForDate(date)}</td>
                );
            }else if( columnMetadataMap.get(key).toLowerCase()==="year"){
                const date = new Date(value).getFullYear();
                return(
                    <td key={key + "-" + date + "-td"}>{date}</td>
                );
            }else if (columnMetadataMap.get(key).toLowerCase()==="bit" || columnMetadataMap.get(key).toLowerCase()==="bool"){
                if (value){
                    return (
                        <td key={key + "-" + value + "-td"}>True</td>
                    );
                }else if (value == null){
                    return (
                        <td key={key + "-" + value + "-td"}></td>
                    );
                }else {
                    return (
                        <td key={key + "-" + value + "-td"}>False</td>
                    );
                }
            } else{
                return(
                    <td key={key + "-" + value + "-td"}>{value}</td>
                );
            }
        });
    };

    const dateFormat = (date) => {
        let reportCreationTime = new Date(date);
        let res = reportCreationTime.getFullYear() + "-" + String(reportCreationTime.getMonth() + 1).padStart(2, '0')
            + "-" + String(reportCreationTime.getDate()).padStart(2, '0') + " " + String(reportCreationTime.getHours()).padStart(2, '0') + ":"
            + String(reportCreationTime.getMinutes()).padStart(2, '0');

        return res;
    }

    const dateFormatForDate = (date) => {
        let reportCreationTime = new Date(date);
        let res = reportCreationTime.getFullYear() + "-" + String(reportCreationTime.getMonth() + 1).padStart(2, '0')
            + "-" + String(reportCreationTime.getDate()).padStart(2, '0');
        return res;
    }


    // const renderExcelDownloadButton = () => {
    //     const model = {columnValueMap: columnValueMap, columnListValueMap: null, offset: comingOffset*comingRowNumber, rows: comingRowNumber};
    //
    //     return(
    //         <DownloadFile parameters={model} fileType={"excel"}/>
    //     );
    // }
    //
    // const renderCsvDownloadButton = () => {
    //     const model = {columnValueMap: columnValueMap, columnListValueMap: null, offset: comingOffset*comingRowNumber, rows: comingRowNumber};
    //
    //     return(
    //         <DownloadFile parameters={model} fileType={"csv"}/>
    //     );
    // }

    const renderTableInfo = () => {

        let tableInfo = "";

        if (reports.reports.filtered){
            let max = comingRowNumber*(comingOffset+1) > reports.reports.filteredEntries ? reports.reports.filteredEntries:comingRowNumber*(comingOffset+1);
            tableInfo = "Showing " + (comingRowNumber*comingOffset+1) + " to " + max + " of " + reports.reports.filteredEntries + " entries (filtered from " + reports.reports.totalEntries + " total entries)";
        }else{
            let max = comingRowNumber*(comingOffset+1) > reports.reports.totalEntries ? reports.reports.totalEntries:comingRowNumber*(comingOffset+1);
            tableInfo = "Showing " + (comingRowNumber*comingOffset+1) + " to " + max + " of " + reports.reports.totalEntries + " entries";
        }

        return(
            <div style={{float: "left", marginTop: "14px", }}>
                <span style={{fontSize:"14px", fontWeight:"500", color: "#1d0101"}}>
                    {tableInfo}
                </span>
            </div>
        );
    };

    const renderDownloadModal = () => {
        const model = {columnValueMap: columnValueMap, offset: comingOffset*comingRowNumber, rows: comingRowNumber, rid: rid};
        return(
            <DownloadModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                model = {model}
                reportName = {props.reportName}
            />
        );
    };

    return(
        <div>
            <div id="report-list-panel">
                {renderTable()}
                {renderDownloadModal()}
            </div>
        </div>
    );

};

function DownloadModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                <span id="connection-form-panel-title">Export Report</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <DownloadForm model={props.model} reportName={props.reportName}/>
        </Modal.Body>
      </Modal>
    );
}

export default ReportList;
